var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRotation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1201,
    height: 1136,
    viewBox: "0 0 1201 1136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    },
    opacity: 0.8,
    filter: "url(#filter0_f)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M718.353 870.006C718.353 866.649 713.155 866.649 713.155 870.006C713.155 873.363 718.353 873.363 718.353 870.006Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M824.09 587.075C824.09 583.718 818.891 583.718 818.891 587.075C818.891 590.432 824.09 590.432 824.09 587.075Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M707.125 591.061C707.125 587.704 701.926 587.704 701.926 591.061C701.926 594.418 707.125 594.418 707.125 591.061Z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M820.139 758.701C820.139 755.344 814.94 755.344 814.94 758.701C814.94 762.058 820.139 762.058 820.139 758.701Z",
    fill: "url(#paint3_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M736.756 739.398C736.756 736.041 731.557 736.041 731.557 739.398C731.557 742.86 736.756 742.86 736.756 739.398Z",
    fill: "url(#paint4_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M836.566 988.55C836.15 988.55 835.734 988.55 835.214 988.55C833.863 988.55 832.511 989.704 832.615 991.173C832.719 992.641 833.759 993.795 835.214 993.795C835.63 993.795 836.046 993.795 836.566 993.795C837.918 993.795 839.269 992.641 839.165 991.173C839.061 989.809 838.022 988.55 836.566 988.55Z",
    fill: "url(#paint5_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M708.684 995.998C708.268 996.418 707.852 996.838 707.333 997.362C706.397 998.306 706.293 1000.09 707.333 1001.03C708.372 1001.98 709.932 1002.08 710.972 1001.03C711.387 1000.61 711.803 1000.19 712.323 999.67C713.259 998.726 713.363 996.943 712.323 995.998C711.283 995.054 709.724 994.949 708.684 995.998Z",
    fill: "url(#paint6_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M801.113 919.627C801.113 916.27 795.914 916.27 795.914 919.627C795.914 922.984 801.113 922.984 801.113 919.627Z",
    fill: "url(#paint7_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M723.552 465.174C723.552 461.817 718.353 461.817 718.353 465.174C718.353 468.531 723.552 468.531 723.552 465.174Z",
    fill: "url(#paint8_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M849.666 392.265C849.666 388.908 844.468 388.908 844.468 392.265C844.468 395.622 849.666 395.622 849.666 392.265Z",
    fill: "url(#paint9_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M885.12 454.579C885.12 451.222 879.921 451.222 879.921 454.579C879.921 457.936 885.12 457.936 885.12 454.579Z",
    fill: "url(#paint10_linear)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M995.431 557.911C995.431 554.554 990.232 554.554 990.232 557.911C990.232 561.268 995.431 561.268 995.431 557.911Z",
    fill: "url(#paint11_linear)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M872.019 669.216C872.019 665.859 866.821 665.859 866.821 669.216C866.821 672.573 872.019 672.573 872.019 669.216Z",
    fill: "url(#paint12_linear)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1005.93 681.176C1005.93 677.819 1000.73 677.819 1000.73 681.176C1000.73 684.533 1005.93 684.533 1005.93 681.176Z",
    fill: "url(#paint13_linear)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M979.731 808.322C979.731 804.965 974.533 804.965 974.533 808.322C974.533 811.679 979.731 811.679 979.731 808.322Z",
    fill: "url(#paint14_linear)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M966.527 869.272C966.527 865.915 961.329 865.915 961.329 869.272C961.329 872.629 966.527 872.629 966.527 869.272Z",
    fill: "url(#paint15_linear)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1021.73 927.6C1021.73 924.243 1016.54 924.243 1016.54 927.6C1016.54 930.957 1021.73 930.957 1021.73 927.6Z",
    fill: "url(#paint16_linear)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M999.381 1003.13C999.381 999.775 994.183 999.775 994.183 1003.13C994.183 1006.49 999.381 1006.49 999.381 1003.13Z",
    fill: "url(#paint17_linear)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1117.59 993.9C1117.59 990.543 1112.4 990.543 1112.4 993.9C1112.4 997.257 1117.59 997.257 1117.59 993.9Z",
    fill: "url(#paint18_linear)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M1091.29 810.944C1091.29 807.587 1086.09 807.587 1086.09 810.944C1086.09 814.406 1091.29 814.406 1091.29 810.944Z",
    fill: "url(#paint19_linear)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1155.65 610.889C1155.65 607.532 1150.45 607.532 1150.45 610.889C1150.45 614.246 1155.65 614.246 1155.65 610.889Z",
    fill: "url(#paint20_linear)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M1062.39 718.207C1062.39 714.85 1057.19 714.85 1057.19 718.207C1057.19 721.564 1062.39 721.564 1062.39 718.207Z",
    fill: "url(#paint21_linear)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M1118.43 518.676C1118.84 519.096 1119.26 519.515 1119.78 520.04C1120.71 520.984 1122.48 521.089 1123.42 520.04C1124.35 518.991 1124.46 517.417 1123.42 516.368C1123 515.949 1122.58 515.529 1122.06 515.004C1121.13 514.06 1119.36 513.955 1118.43 515.004C1117.49 516.054 1117.39 517.627 1118.43 518.676Z",
    fill: "url(#paint22_linear)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M1076.84 433.283C1076.84 429.926 1071.64 429.926 1071.64 433.283C1071.64 436.745 1076.84 436.745 1076.84 433.283Z",
    fill: "url(#paint23_linear)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M974.429 394.887C974.429 391.53 969.23 391.53 969.23 394.887C969.23 398.244 974.429 398.244 974.429 394.887Z",
    fill: "url(#paint24_linear)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M1154.4 287.568C1154.4 284.211 1149.2 284.211 1149.2 287.568C1149.2 290.925 1154.4 290.925 1154.4 287.568Z",
    fill: "url(#paint25_linear)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M1011.23 280.959C1011.23 277.602 1006.04 277.602 1006.04 280.959C1006.04 284.316 1011.23 284.316 1011.23 280.959Z",
    fill: "url(#paint26_linear)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M822.114 275.609C822.114 272.252 816.916 272.252 816.916 275.609C816.916 278.966 822.114 279.071 822.114 275.609Z",
    fill: "url(#paint27_linear)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M709.1 283.582C709.1 280.225 703.902 280.225 703.902 283.582C703.902 286.939 709.1 286.939 709.1 283.582Z",
    fill: "url(#paint28_linear)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M717.002 359.114C717.002 355.757 711.803 355.757 711.803 359.114C711.803 362.471 717.002 362.471 717.002 359.114Z",
    fill: "url(#paint29_linear)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M1168.75 814.931C1168.75 811.574 1163.55 811.574 1163.55 814.931C1163.55 818.393 1168.75 818.393 1168.75 814.931Z",
    fill: "url(#paint30_linear)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M1126.74 902.422C1126.74 899.065 1121.54 899.065 1121.54 902.422C1121.54 905.779 1126.74 905.779 1126.74 902.422Z",
    fill: "url(#paint31_linear)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M752.455 995.159C752.455 993.481 749.856 993.481 749.856 995.159C749.856 996.838 752.455 996.838 752.455 995.159Z",
    fill: "url(#paint32_linear)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M702.55 931.586C702.55 929.908 699.951 929.908 699.951 931.586C699.951 933.265 702.55 933.265 702.55 931.586Z",
    fill: "url(#paint33_linear)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M713.051 803.076C713.051 801.398 710.452 801.398 710.452 803.076C710.452 804.755 713.051 804.755 713.051 803.076Z",
    fill: "url(#paint34_linear)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M770.858 862.663C770.858 860.984 768.258 860.984 768.258 862.663C768.258 864.341 770.858 864.341 770.858 862.663Z",
    fill: "url(#paint35_linear)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M735.404 515.529C735.404 513.851 732.805 513.851 732.805 515.529C732.805 517.208 735.404 517.208 735.404 515.529Z",
    fill: "url(#paint36_linear)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M717.002 661.243C717.002 659.565 714.402 659.565 714.402 661.243C714.402 662.922 717.002 662.922 717.002 661.243Z",
    fill: "url(#paint37_linear)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M727.503 592.32C727.503 590.642 724.903 590.642 724.903 592.32C724.903 593.999 727.503 593.999 727.503 592.32Z",
    fill: "url(#paint38_linear)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M736.756 454.579C736.756 452.9 734.157 452.9 734.157 454.579C734.157 456.257 736.756 456.257 736.756 454.579Z",
    fill: "url(#paint39_linear)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M854.969 439.997C854.969 438.318 852.369 438.318 852.369 439.997C852.369 441.675 854.969 441.675 854.969 439.997Z",
    fill: "url(#paint40_linear)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M887.719 432.024C887.719 430.345 885.12 430.345 885.12 432.024C885.12 433.702 887.719 433.702 887.719 432.024Z",
    fill: "url(#paint41_linear)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M791.859 413.456C791.859 411.777 789.26 411.777 789.26 413.456C789.26 415.134 791.859 415.134 791.859 413.456Z",
    fill: "url(#paint42_linear)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M807.663 386.914C807.663 385.236 805.063 385.236 805.063 386.914C805.063 388.593 807.663 388.593 807.663 386.914Z",
    fill: "url(#paint43_linear)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M806.311 295.541C806.311 293.863 803.712 293.863 803.712 295.541C803.712 297.22 806.311 297.22 806.311 295.541Z",
    fill: "url(#paint44_linear)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M865.469 269C865.053 269 864.638 269 864.118 269C862.454 269 862.454 271.623 864.118 271.623C864.534 271.623 864.95 271.623 865.469 271.623C867.133 271.623 867.133 269 865.469 269Z",
    fill: "url(#paint45_linear)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M730.206 283.582C730.206 281.903 727.607 281.903 727.607 283.582C727.607 285.26 730.206 285.26 730.206 283.582Z",
    fill: "url(#paint46_linear)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M1003.33 368.451C1003.33 366.772 1000.73 366.772 1000.73 368.451C1000.73 370.129 1003.33 370.129 1003.33 368.451Z",
    fill: "url(#paint47_linear)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M998.03 396.251C998.03 394.572 995.431 394.572 995.431 396.251C995.431 397.929 998.03 397.929 998.03 396.251Z",
    fill: "url(#paint48_linear)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M990.232 283.582C990.232 281.903 987.633 281.903 987.633 283.582C987.633 285.26 990.232 285.26 990.232 283.582Z",
    fill: "url(#paint49_linear)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M1053.24 450.592C1053.24 448.914 1050.64 448.914 1050.64 450.592C1050.64 452.271 1053.24 452.271 1053.24 450.592Z",
    fill: "url(#paint50_linear)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M1070.29 463.81C1070.29 462.132 1067.69 462.132 1067.69 463.81C1067.69 465.489 1070.29 465.489 1070.29 463.81Z",
    fill: "url(#paint51_linear)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M991.48 585.711C991.48 584.033 988.881 584.033 988.881 585.711C988.881 587.39 991.48 587.39 991.48 585.711Z",
    fill: "url(#paint52_linear)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M1012.48 557.911C1012.48 556.233 1009.88 556.233 1009.88 557.911C1009.88 559.59 1012.48 559.59 1012.48 557.911Z",
    fill: "url(#paint53_linear)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M973.181 711.598C973.597 711.598 974.013 711.598 974.533 711.598C976.196 711.598 976.196 708.976 974.533 708.976C974.117 708.976 973.701 708.976 973.181 708.976C971.518 708.976 971.414 711.598 973.181 711.598Z",
    fill: "url(#paint54_linear)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M980.979 673.203C980.979 671.524 978.38 671.524 978.38 673.203C978.38 674.881 980.979 674.881 980.979 673.203Z",
    fill: "url(#paint55_linear)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M843.116 743.385C843.116 741.706 840.517 741.706 840.517 743.385C840.517 745.063 843.116 745.063 843.116 743.385Z",
    fill: "url(#paint56_linear)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M840.517 887.84C840.517 886.162 837.918 886.162 837.918 887.84C837.918 889.519 840.517 889.519 840.517 887.84Z",
    fill: "url(#paint57_linear)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M807.663 869.272C807.663 867.594 805.063 867.594 805.063 869.272C805.063 870.951 807.663 870.951 807.663 869.272Z",
    fill: "url(#paint58_linear)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M807.663 987.186C807.663 985.508 805.063 985.508 805.063 987.186C805.063 988.97 807.663 988.97 807.663 987.186Z",
    fill: "url(#paint59_linear)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M1013.83 901.059C1013.83 899.38 1011.23 899.38 1011.23 901.059C1011.23 902.737 1013.83 902.842 1013.83 901.059Z",
    fill: "url(#paint60_linear)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M1025.69 979.318C1025.69 977.64 1023.09 977.64 1023.09 979.318C1023.09 980.997 1025.69 980.997 1025.69 979.318Z",
    fill: "url(#paint61_linear)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M1099.19 996.523C1099.19 994.845 1096.59 994.845 1096.59 996.523C1096.59 998.202 1099.19 998.202 1099.19 996.523Z",
    fill: "url(#paint62_linear)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M1141.19 962.009C1141.19 960.33 1138.6 960.33 1138.6 962.009C1138.6 963.792 1141.19 963.792 1141.19 962.009Z",
    fill: "url(#paint63_linear)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M1178 1009.74C1178 1008.06 1175.4 1008.06 1175.4 1009.74C1175.4 1011.42 1178 1011.42 1178 1009.74Z",
    fill: "url(#paint64_linear)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M1111.04 857.418C1111.04 855.739 1108.44 855.739 1108.44 857.418C1108.44 859.096 1111.04 859.096 1111.04 857.418Z",
    fill: "url(#paint65_linear)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M1088.69 911.654C1088.69 909.976 1086.09 909.976 1086.09 911.654C1086.09 913.437 1088.69 913.437 1088.69 911.654Z",
    fill: "url(#paint66_linear)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M1174.05 779.158C1174.05 777.479 1171.45 777.479 1171.45 779.158C1171.45 780.836 1174.05 780.836 1174.05 779.158Z",
    fill: "url(#paint67_linear)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M1076.84 694.394C1076.84 692.715 1074.24 692.715 1074.24 694.394C1074.24 696.072 1076.84 696.072 1076.84 694.394Z",
    fill: "url(#paint68_linear)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M1163.55 644.039C1163.55 642.36 1160.95 642.36 1160.95 644.039C1160.95 645.717 1163.55 645.717 1163.55 644.039Z",
    fill: "url(#paint69_linear)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M1120.19 610.889C1120.19 609.21 1117.59 609.21 1117.59 610.889C1117.59 612.567 1120.19 612.567 1120.19 610.889Z",
    fill: "url(#paint70_linear)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M1141.19 503.57C1141.19 501.891 1138.6 501.891 1138.6 503.57C1138.6 505.248 1141.19 505.248 1141.19 503.57Z",
    fill: "url(#paint71_linear)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M990.232 477.029C990.232 475.35 987.633 475.35 987.633 477.029C987.633 478.707 990.232 478.707 990.232 477.029Z",
    fill: "url(#paint72_linear)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M1059.79 511.543C1059.79 511.123 1059.79 510.703 1059.79 510.179C1059.79 508.5 1057.19 508.5 1057.19 510.179C1057.19 510.598 1057.19 511.018 1057.19 511.543C1057.19 513.221 1059.79 513.221 1059.79 511.543Z",
    fill: "url(#paint73_linear)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M1071.64 357.75C1071.64 356.072 1069.04 356.072 1069.04 357.75C1069.04 359.534 1071.64 359.534 1071.64 357.75Z",
    fill: "url(#paint74_linear)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M1163.55 428.037C1163.55 426.359 1160.95 426.359 1160.95 428.037C1160.95 429.716 1163.55 429.716 1163.55 428.037Z",
    fill: "url(#paint75_linear)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M1175.4 343.273C1175.4 341.595 1172.8 341.595 1172.8 343.273C1172.8 344.952 1175.4 344.952 1175.4 343.273Z",
    fill: "url(#paint76_linear)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M1142.55 303.514C1142.55 301.835 1139.95 301.835 1139.95 303.514C1139.95 305.192 1142.55 305.192 1142.55 303.514Z",
    fill: "url(#paint77_linear)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M1118.95 280.959C1118.95 279.281 1116.35 279.281 1116.35 280.959C1116.35 282.638 1118.95 282.638 1118.95 280.959Z",
    fill: "url(#paint78_linear)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M776.16 576.479C776.16 574.801 773.561 574.801 773.561 576.479C773.561 578.158 776.16 578.158 776.16 576.479Z",
    fill: "url(#paint79_linear)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M698.599 414.819C698.599 413.141 696 413.141 696 414.819C696 416.498 698.599 416.498 698.599 414.819Z",
    fill: "url(#paint80_linear)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M774.808 482.379C774.808 480.7 772.209 480.7 772.209 482.379C772.209 484.057 774.808 484.057 774.808 482.379Z",
    fill: "url(#paint81_linear)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M772.209 801.713C772.209 800.034 769.61 800.034 769.61 801.713C769.61 803.391 772.209 803.391 772.209 801.713Z",
    fill: "url(#paint82_linear)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M1041.38 768.562C1041.38 766.884 1038.79 766.884 1038.79 768.562C1038.79 770.241 1041.38 770.241 1041.38 768.562Z",
    fill: "url(#paint83_linear)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M1005.93 809.685C1005.93 808.007 1003.33 808.007 1003.33 809.685C1003.33 811.364 1005.93 811.364 1005.93 809.685Z",
    fill: "url(#paint84_linear)"
  }))), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M701.072 631.686C735.968 596.493 735.968 539.433 701.073 504.24C666.177 469.047 609.6 469.047 574.704 504.24C539.808 539.433 539.808 596.493 574.704 631.686C609.6 666.879 666.177 666.879 701.072 631.686Z",
    stroke: "url(#paint85_linear)",
    strokeWidth: 1.72165,
    strokeMiterlimit: 10
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M637.893 695.023C707.453 695.023 763.843 638.153 763.843 568C763.843 497.847 707.453 440.977 637.893 440.977C568.333 440.977 511.943 497.847 511.943 568C511.943 638.153 568.333 695.023 637.893 695.023Z",
    stroke: "url(#paint86_linear)",
    strokeWidth: 1.72165,
    strokeMiterlimit: 10
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M760.076 691.191C827.558 623.134 827.558 512.792 760.076 444.735C692.594 376.678 583.184 376.678 515.702 444.735C448.221 512.792 448.221 623.134 515.702 691.191C583.184 759.248 692.594 759.248 760.076 691.191Z",
    stroke: "url(#paint87_linear)",
    strokeWidth: 1.72165,
    strokeMiterlimit: 10
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M791.833 723.217C876.853 637.473 876.853 498.453 791.833 412.709C706.813 326.964 568.968 326.964 483.948 412.709C398.928 498.453 398.928 637.473 483.948 723.217C568.968 808.962 706.813 808.962 791.833 723.217Z",
    stroke: "url(#paint88_linear)",
    strokeWidth: 1.72165,
    strokeMiterlimit: 10
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M637.892 855.502C795.334 855.502 922.966 726.783 922.966 567.999C922.966 409.216 795.334 280.496 637.892 280.496C480.45 280.496 352.818 409.216 352.818 567.999C352.818 726.783 480.45 855.502 637.892 855.502Z",
    stroke: "url(#paint89_linear)",
    strokeWidth: 1.72165,
    strokeMiterlimit: 10
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M637.892 957.363C851.115 957.363 1023.97 783.039 1023.97 567.999C1023.97 352.959 851.115 178.635 637.892 178.635C424.67 178.635 251.818 352.959 251.818 567.999C251.818 783.039 424.67 957.363 637.892 957.363Z",
    stroke: "url(#paint90_linear)",
    strokeWidth: 1.72165,
    strokeMiterlimit: 10
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M637.893 1041.61C897.251 1041.61 1107.5 829.568 1107.5 568C1107.5 306.432 897.251 94.3887 637.893 94.3887C378.534 94.3887 168.283 306.432 168.283 568C168.283 829.568 378.534 1041.61 637.893 1041.61Z",
    stroke: "url(#paint91_linear)",
    strokeWidth: 1.72165,
    strokeMiterlimit: 10
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M637.893 1097.15C927.667 1097.15 1162.58 860.243 1162.58 567.999C1162.58 275.755 927.667 38.8438 637.893 38.8438C348.118 38.8438 113.209 275.755 113.209 567.999C113.209 860.243 348.118 1097.15 637.893 1097.15Z",
    stroke: "url(#paint92_linear)",
    strokeWidth: 1.72165,
    strokeMiterlimit: 10
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M637.8 1134.99C948.295 1134.99 1200 881.14 1200 567.999C1200 254.859 948.295 1.00781 637.8 1.00781C327.305 1.00781 75.5996 254.859 75.5996 567.999C75.5996 881.14 327.305 1134.99 637.8 1134.99Z",
    stroke: "url(#paint93_linear)",
    strokeWidth: 1.72165,
    strokeMiterlimit: 10
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 223.08,
    width: 768.274,
    height: 689.84,
    fill: "url(#paint94_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f",
    x: 694,
    y: 267,
    width: 486,
    height: 746,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 937,
    y1: 269,
    x2: 937,
    y2: 1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 937,
    y1: 269,
    x2: 937,
    y2: 1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 937,
    y1: 269,
    x2: 937,
    y2: 1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 937,
    y1: 269,
    x2: 937,
    y2: 1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 937,
    y1: 269,
    x2: 937,
    y2: 1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 937,
    y1: 269,
    x2: 937,
    y2: 1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 937,
    y1: 269,
    x2: 937,
    y2: 1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 937,
    y1: 269,
    x2: 937,
    y2: 1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 937,
    y1: 269,
    x2: 937,
    y2: 1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 937,
    y1: 269,
    x2: 937,
    y2: 1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 937,
    y1: 269,
    x2: 937,
    y2: 1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 937,
    y1: 269,
    x2: 937,
    y2: 1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 937,
    y1: 269,
    x2: 937,
    y2: 1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 937,
    y1: 269,
    x2: 937,
    y2: 1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 937,
    y1: 269,
    x2: 937,
    y2: 1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: 937,
    y1: 269,
    x2: 937,
    y2: 1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x1: 937,
    y1: 269,
    x2: 937,
    y2: 1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear",
    x1: 937,
    y1: 269,
    x2: 937,
    y2: 1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear",
    x1: 937,
    y1: 269,
    x2: 937,
    y2: 1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear",
    x1: 937,
    y1: 269,
    x2: 937,
    y2: 1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear",
    x1: 937,
    y1: 269,
    x2: 937,
    y2: 1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear",
    x1: 937,
    y1: 269,
    x2: 937,
    y2: 1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear",
    x1: 937,
    y1: 269,
    x2: 937,
    y2: 1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear",
    x1: 937,
    y1: 269,
    x2: 937,
    y2: 1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear",
    x1: 937,
    y1: 269,
    x2: 937,
    y2: 1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear",
    x1: 937,
    y1: 269,
    x2: 937,
    y2: 1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear",
    x1: 937,
    y1: 269,
    x2: 937,
    y2: 1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear",
    x1: 937,
    y1: 269,
    x2: 937,
    y2: 1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear",
    x1: 937,
    y1: 269,
    x2: 937,
    y2: 1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear",
    x1: 937,
    y1: 269,
    x2: 937,
    y2: 1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear",
    x1: 937,
    y1: 269,
    x2: 937,
    y2: 1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear",
    x1: 937,
    y1: 269,
    x2: 937,
    y2: 1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear",
    x1: 937,
    y1: 269,
    x2: 937,
    y2: 1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear",
    x1: 937,
    y1: 269,
    x2: 937,
    y2: 1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear",
    x1: 937,
    y1: 269,
    x2: 937,
    y2: 1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear",
    x1: 937,
    y1: 269,
    x2: 937,
    y2: 1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear",
    x1: 937,
    y1: 269,
    x2: 937,
    y2: 1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear",
    x1: 937,
    y1: 269,
    x2: 937,
    y2: 1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear",
    x1: 937,
    y1: 269,
    x2: 937,
    y2: 1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear",
    x1: 937,
    y1: 269,
    x2: 937,
    y2: 1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear",
    x1: 937,
    y1: 269,
    x2: 937,
    y2: 1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear",
    x1: 937,
    y1: 269,
    x2: 937,
    y2: 1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear",
    x1: 937,
    y1: 269,
    x2: 937,
    y2: 1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear",
    x1: 937,
    y1: 269,
    x2: 937,
    y2: 1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear",
    x1: 937,
    y1: 269,
    x2: 937,
    y2: 1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear",
    x1: 937,
    y1: 269,
    x2: 937,
    y2: 1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear",
    x1: 937,
    y1: 269,
    x2: 937,
    y2: 1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear",
    x1: 937,
    y1: 269,
    x2: 937,
    y2: 1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear",
    x1: 937,
    y1: 269,
    x2: 937,
    y2: 1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear",
    x1: 937,
    y1: 269,
    x2: 937,
    y2: 1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear",
    x1: 937,
    y1: 269,
    x2: 937,
    y2: 1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear",
    x1: 937,
    y1: 269,
    x2: 937,
    y2: 1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear",
    x1: 937,
    y1: 269,
    x2: 937,
    y2: 1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear",
    x1: 937,
    y1: 269,
    x2: 937,
    y2: 1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear",
    x1: 937,
    y1: 269,
    x2: 937,
    y2: 1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear",
    x1: 937,
    y1: 269,
    x2: 937,
    y2: 1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear",
    x1: 937,
    y1: 269,
    x2: 937,
    y2: 1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear",
    x1: 937,
    y1: 269,
    x2: 937,
    y2: 1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear",
    x1: 937,
    y1: 269,
    x2: 937,
    y2: 1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear",
    x1: 937,
    y1: 269,
    x2: 937,
    y2: 1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear",
    x1: 937,
    y1: 269,
    x2: 937,
    y2: 1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear",
    x1: 937,
    y1: 269,
    x2: 937,
    y2: 1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear",
    x1: 937,
    y1: 269,
    x2: 937,
    y2: 1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear",
    x1: 937,
    y1: 269,
    x2: 937,
    y2: 1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear",
    x1: 937,
    y1: 269,
    x2: 937,
    y2: 1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear",
    x1: 937,
    y1: 269,
    x2: 937,
    y2: 1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear",
    x1: 937,
    y1: 269,
    x2: 937,
    y2: 1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear",
    x1: 937,
    y1: 269,
    x2: 937,
    y2: 1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear",
    x1: 937,
    y1: 269,
    x2: 937,
    y2: 1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear",
    x1: 937,
    y1: 269,
    x2: 937,
    y2: 1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear",
    x1: 937,
    y1: 269,
    x2: 937,
    y2: 1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear",
    x1: 937,
    y1: 269,
    x2: 937,
    y2: 1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear",
    x1: 937,
    y1: 269,
    x2: 937,
    y2: 1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear",
    x1: 937,
    y1: 269,
    x2: 937,
    y2: 1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear",
    x1: 937,
    y1: 269,
    x2: 937,
    y2: 1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear",
    x1: 937,
    y1: 269,
    x2: 937,
    y2: 1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear",
    x1: 937,
    y1: 269,
    x2: 937,
    y2: 1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear",
    x1: 937,
    y1: 269,
    x2: 937,
    y2: 1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear",
    x1: 937,
    y1: 269,
    x2: 937,
    y2: 1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear",
    x1: 937,
    y1: 269,
    x2: 937,
    y2: 1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear",
    x1: 937,
    y1: 269,
    x2: 937,
    y2: 1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear",
    x1: 937,
    y1: 269,
    x2: 937,
    y2: 1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear",
    x1: 937,
    y1: 269,
    x2: 937,
    y2: 1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear",
    x1: 937,
    y1: 269,
    x2: 937,
    y2: 1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear",
    x1: 937,
    y1: 269,
    x2: 937,
    y2: 1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear",
    x1: 574.335,
    y1: 503.927,
    x2: 702.427,
    y2: 630.936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear",
    x1: 637.852,
    y1: 440.467,
    x2: 637.852,
    y2: 695.484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear",
    x1: 515.349,
    y1: 444.437,
    x2: 762.416,
    y2: 689.417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear",
    x1: 483.557,
    y1: 412.373,
    x2: 794.75,
    y2: 720.936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear",
    x1: 637.851,
    y1: 279.973,
    x2: 637.851,
    y2: 855.977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear",
    x1: 637.851,
    y1: 178.136,
    x2: 637.851,
    y2: 957.813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear",
    x1: 637.851,
    y1: 93.9015,
    x2: 637.851,
    y2: 1042.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear",
    x1: 637.851,
    y1: 38.3239,
    x2: 637.851,
    y2: 1097.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear",
    x1: 637.776,
    y1: 0.541843,
    x2: 637.776,
    y2: 1135.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1277,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.827,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear",
    x1: 34.1572,
    y1: 605.799,
    x2: 724.385,
    y2: 856.565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.442091
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotation);
export default __webpack_public_path__ + "static/media/Rotation.d8a042997e78795306c22594a9466878.svg";
export { ForwardRef as ReactComponent };